import React from 'react';
import {
  CheckCircle,
  Crown,
  Target,
  Users,
  Zap,
  TrendingUp,
  Globe,
  Monitor,
  Map,
} from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <CheckCircle className="w-8 h-8 text-elion-gold" />,
      title: 'Acesso Ilimitado',
      description:
        'Comercialize imóveis das principais incorporadoras do país, sem limites.',
    },
    {
      icon: <Crown className="w-8 h-8 text-elion-gold" />,
      title: '100% da Comissão',
      description:
        'Você mantém todo o faturamento de cada venda, sem divisões.',
    },
    {
      icon: <Target className="w-8 h-8 text-elion-gold" />,
      title: 'Sua Marca em Evidência',
      description: 'Construa sua reputação e tenha sua marca em destaque.',
    },
    {
      icon: <Users className="w-8 h-8 text-elion-gold" />,
      title: 'Rede de Relacionamentos',
      description: 'Conecte-se com sócios e crie novas oportunidades.',
    },
    {
      icon: <Zap className="w-8 h-8 text-elion-gold" />,
      title: 'Tecnologia de Alta Performance',
      description: 'Ferramentas modernas e simples de usar.',
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-elion-gold" />,
      title: 'Escalabilidade Real',
      description: 'Cresça seu negócio sem limites com nosso modelo digital.',
    },
    {
      icon: <Globe className="w-8 h-8 text-elion-gold" />,
      title: 'Sua Vitrine de Imóveis',
      description:
        'Crie seu site profissional e apresente seu portfólio a qualquer cliente.',
    },
    {
      icon: <Monitor className="w-8 h-8 text-elion-gold" />,
      title: 'Liberdade Operacional',
      description:
        'Atue de onde quiser, com total controle da sua operação imobiliária.',
    },
    {
      icon: <Map className="w-8 h-8 text-elion-gold" />,
      title: 'Alcance Nacional',
      description: 'Venda imóveis em qualquer lugar do Brasil, sem fronteiras.',
    },
  ];

  return (
    <section className="bg-elion-navy py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Benefícios Elion
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 rounded-xl p-6 text-center"
            >
              <div className="flex justify-center mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-elion-navy mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
